import { useTranslation } from "react-i18next";
import adImage from "../../Assests/sleek-red-sports-sedan-isolated-transparent-background-showcasing-its-modern-design-luxurious-features-perfect-image-automotive-advertising-design-projects_632498-27351.jpg"
import userImage from "../../Assests/images.jpg"
import { useNavigate } from "react-router-dom";

export default function UserMostUi ({value}) {

    const { t } = useTranslation();
    const nav = useNavigate();

    const handleNav = (id) => {
        nav(`/users/details/${id}`);
    };

    return(<>
        {/* Section 1: Most Active Users */}
        <div className='bg-thirdly rounded-lg p-5'>
            <label className='text-white font-semiblod text-xl text-right'>{t("charts.most_active_users")}</label>
            <div className='flex sm:flex-row flex-col sm:justify-between sm:items-center gap-8 px-4 mt-4 mb-4'>

                {value?.most_active_user?.map((user) => (
                    <div key={user?.id} onClick={()=> handleNav(user?.id)} className='flex sm:flex-row flex-col justify-center items-center sm:justify-between sm:items-start cursor-pointer'>
                        {/* Kept adImage as per your original code for this section */}
                        <img src={adImage} className='w-14 h-14 rounded-lg' alt="User Icon"/>
                        <div className='sm:ms-4 mt-1'>
                            <h2 className='text-white text-bold text-md'>{user?.full_name}</h2>
                            <p className='text-white text-bold text-sm mt-2'>{user?.email}</p>
                        </div>
                    </div>
                ))}

            </div>
        </div>

        {/* Section 2: Highest Revenue Clients */}
        <div className='bg-thirdly rounded-lg p-5 mt-5'>
            <label className='text-white font-semiblod text-xl text-right'>{t("charts.highest_revenue_clients")}</label>
            <div className='flex sm:flex-row flex-col sm:justify-between sm:items-center gap-8 px-4 mt-4 mb-4'>

                {value?.most_revenue_user?.map((user) => (
                    <div key={user.id} onClick={()=> handleNav(user?.id)} className='flex sm:flex-row flex-col justify-center items-center sm:justify-between sm:items-start cursor-pointer'>
                        {/* Kept userImage as per your original code for this section */}
                        <img src={userImage} className='w-14 h-14 rounded-lg' alt="User Icon"/>
                        <div className='sm:ms-4 mt-1'>
                            <h2 className='text-white text-bold text-md'>{user?.full_name}</h2>
                            <p className='text-white text-bold text-sm mt-2'>{user?.email}</p>
                        </div>
                    </div>
                ))}

            </div>
        </div>  
    </>);
};